"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceFilter = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var semantic_ui_react_1 = require("semantic-ui-react");
var useTranslationNs_1 = require("../../../hooks/useTranslationNs");
var FilterDropdown_1 = __importDefault(require("../FilterDropdown"));
var FilterSummary_1 = __importDefault(require("../FilterSummary"));
var ChoiceFilter = function (_a) {
    var filter = _a.filter, toggleDropdown = _a.toggleDropdown, changeFilter = _a.changeFilter, appliedFilters = _a.appliedFilters;
    var t = react_i18next_1.useTranslation('common').t;
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    var options = filter.options, label = filter.label;
    var getInitialState = function () {
        var _a;
        var initialState = '';
        if (filter.component === 'MultipleChoice') {
            initialState = [];
            if (appliedFilters[filter.name] &&
                lodash_1.isArray(appliedFilters[filter.name])) {
                initialState = appliedFilters[filter.name];
            }
        }
        else {
            initialState = (_a = appliedFilters[filter.name]) !== null && _a !== void 0 ? _a : '';
        }
        return initialState;
    };
    var selectionType = filter.component === 'MultipleChoice' ? 'multiple' : 'single';
    react_2.useEffect(function () {
        setSelected(getInitialState());
    }, [appliedFilters]);
    var _b = react_1.useState(getInitialState()), selected = _b[0], setSelected = _b[1];
    var getLabelByValOrText = function (val) {
        var label = '';
        for (var i = 0; i < filter.options.length; i++) {
            if ((filter.options[i].val && filter.options[i].val === val) ||
                (filter.options[i].text && filter.options[i].text === val)) {
                label = filter.options[i].text;
                break;
            }
        }
        return label;
    };
    var formSelectedValue = function () {
        var ignoreTranslation = filter.ignoreTranslation;
        if (selected) {
            if (lodash_1.isArray(selected) && selected.length > 0) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "choosen-val" }, !ignoreTranslation
                        ? t('FIELD_OPTIONS.' + selected[0])
                        : getLabelByValOrText(selected[0])),
                    selected.length > 1 && (react_1.default.createElement("span", { className: "selected-count" },
                        "+",
                        selected.length - 1))));
            }
            else {
                if (lodash_1.isString(selected)) {
                    return (react_1.default.createElement("span", null, ignoreTranslation
                        ? selected
                        : t('FIELD_OPTIONS.' + selected)));
                }
            }
        }
        return react_1.default.createElement("span", { className: "default-val" }, getTranslation('CHOOSE'));
    };
    var toggleSelect = function (val) {
        if (filter.component === 'SingleChoice') {
            setSelected(val);
        }
        if (lodash_1.isArray(selected) && filter.component === 'MultipleChoice') {
            if (selected.indexOf(val) >= 0) {
                setSelected(__spreadArray([], selected.filter(function (txt) { return txt != val; })));
            }
            else {
                setSelected(__spreadArray(__spreadArray([], selected), [val]));
            }
        }
        changeFilter(filter.name, val, false, filter.component === 'SingleChoice');
    };
    /**
     * Forms Radio or Checkbox component based on selection type single | multiple
     */
    var getChoiceBySelectionType = function (item) {
        var returnElement = react_1.default.createElement(react_1.default.Fragment, null);
        switch (selectionType) {
            case 'single':
                var isSingleChecked = item.text === selected || item.val === selected;
                returnElement = (react_1.default.createElement(semantic_ui_react_1.Radio, { label: t('FIELD_OPTIONS.' + item.text, item.text), onChange: function () { var _a; return toggleSelect((_a = item.val) !== null && _a !== void 0 ? _a : item.text); }, checked: isSingleChecked }));
                break;
            case 'multiple':
                var isMultipleChecked = selected.indexOf(item.text) >= 0 ||
                    selected.indexOf(item.val) >= 0;
                returnElement = (react_1.default.createElement(semantic_ui_react_1.Checkbox, { label: t('FIELD_OPTIONS.' + item.text, item.text), onChange: function () { var _a; return toggleSelect((_a = item.val) !== null && _a !== void 0 ? _a : item.text); }, checked: isMultipleChecked }));
                break;
            default:
                console.warn("ChoiceFilter selection type is missing or incorrect!");
                break;
        }
        return returnElement;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterSummary_1.default, { handleClick: toggleDropdown, label: label.toLocaleUpperCase() }, formSelectedValue()),
        react_1.default.createElement(FilterDropdown_1.default, { handleClick: toggleDropdown, label: label.toUpperCase(), filterName: filter.name },
            react_1.default.createElement("ul", { className: "choices" }, options.map(function (item, index) {
                return (react_1.default.createElement("li", { key: index }, getChoiceBySelectionType(item)));
            })))));
};
exports.ChoiceFilter = ChoiceFilter;
